
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src2815122270/src/vl-app/pages/hbsbvt.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import LoginPage from './login';

export const BVT_LOGIN_PATH = '/hbsbvt';

const BVTLoginPage = () => <LoginPage />;

export default BVTLoginPage;
export const Route = createFileRoute('/hbsbvt')({ component: BVTLoginPage });
